import { Carousel } from "react-bootstrap"

export const CarouselVision = () => (
  <Carousel indicators={false} fade={true} interval={10000}>
    {[1, 2, 3, 4].map((value) => (
      <Carousel.Item key={value}>
        <img
          className="d-block w-100"
          src={`images/vision-${value}.jpg`}
          alt={String(value)}
        />
      </Carousel.Item>
    ))}
  </Carousel>
)
